import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

function OtherTab() {
  return (
    <div className='p-4 md:p-6'>
      <div className='flex flex-col gap-y-4 md:gap-y-6'>
        <div className='space-y-2 md:space-y-2'>
          {/* First Row: Date of Birth and ID */}
          <div className='flex items-center gap-2'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Ngày sinh</Label>
              <FormField type='date' name='birth_date' className='w-44' />
            </div>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Số CMND/CCCD</Label>
              <FormField type='text' name='id_number' />
            </div>
          </div>

          {/* Second Row: Representative and Position */}
          <div className='flex items-center gap-2'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Người đại diện p.luật</Label>
              <FormField type='text' name='legal_representative' />
            </div>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Chức vụ</Label>
              <FormField type='text' name='representative_position' />
            </div>
          </div>

          {/* Third Row: Bank Account */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Số tài khoản</Label>
            <FormField type='text' name='bank_account' />
          </div>

          {/* Fourth Row: Bank Name */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên ngân hàng</Label>
            <FormField type='text' name='bank_name' />
          </div>

          {/* Fifth Row: Bank Branch */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Chi nhánh</Label>
            <FormField type='text' name='bank_branch' />
          </div>

          {/* Sixth Row: City/Province */}
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tỉnh thành</Label>
            <FormField type='text' name='province' />
          </div>

          {/* File Upload */}
          {/* <FileSelectField
            labelClassName='mb-2 sm:mb-0 sm:w-32 sm:min-w-32'
            className='flex flex-col sm:flex-row sm:items-center'
          /> */}
        </div>
      </div>
    </div>
  );
}

export default OtherTab;
